import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _objectSpread2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import addUser from "./components/addUser";
import { mapActions } from "vuex";
import rolead from "./components/rolead";
import addRole from '../roles/components/addRole';
import roleGame from '../roles/components/roleGame';
export default {
  name: "users",
  components: {
    addUser: addUser,
    rolead: rolead,
    roleGame: roleGame,
    addRole: addRole
  },
  data: function data() {
    var _ref;

    return _ref = {
      tableData: [],
      addUser: false,
      total: 0,
      page: 1,
      showing: false,
      current_page: 1,
      searchData: {
        page: 1,
        page_size: 10,
        user_name: "",
        son_account: 2
      }
    }, _defineProperty(_ref, "showing", false), _defineProperty(_ref, "presentations", [{
      label: '是',
      value: 2
    }, {
      label: '否',
      value: 1
    }]), _ref;
  },
  activated: function activated() {
    if (this.$route.params.user_name) {
      this.searchData.user_name = this.$route.params.user_name;
    }

    this.getData(this.searchData.page);
    this.$route.params.user_name = "";
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/user", ["usersList", "disableUser", "delUser"])), {}, (_objectSpread2 = {
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleSource: function handleSource(id, type) {
      var _this = this;

      // 添加、修改
      this.addUser = true;
      this.showing = true;
      this.$nextTick(function () {
        _this.$refs.addUser.init(id, type);
      });
    },
    getData: function getData(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.searchData.page = e;
                _context.next = 3;
                return _this2.usersList(_this2.searchData);

              case 3:
                query = _context.sent;
                _this2.tableData = query.data;
                _this2.total = query.total;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.getData(1);
    },
    handleDisable: function handleDisable(id) {
      var _this3 = this;

      this.disableUser({
        id: id
      }).then(function (res) {
        if (res.status == 200) {
          Message({
            message: res.message,
            type: "success"
          });

          _this3.getData(_this3.searchData.page);
        } else {
          Message({
            message: res.message,
            type: "warning"
          });
        }
      });
    }
  }, _defineProperty(_objectSpread2, "changeShow", function changeShow(val) {
    this.showing = val;
  }), _defineProperty(_objectSpread2, "handleDelete", function handleDelete(id) {
    var _this4 = this;

    this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this4.delUser({
                id: id
              });

            case 2:
              _this4.getData(_this4.searchData.page);

              _this4.$message({
                type: "success",
                message: "删除成功!"
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
  }), _objectSpread2))
};